module.exports = __webpack_public_path__ + "static/media/outlet.4b245db6.svg";